import { useContext } from 'react';
import { FirebaseContext } from '../../dealerLocatorFirebaseContextProvider';

const useFirebase = () => {
  const ctx = useContext(FirebaseContext);

  if (ctx === undefined) {
    throw new Error('useFirebase must be used inside FirebaseContextProvider');
  }

  return ctx;
};

export default useFirebase;
